import React from 'react'
import Footer from '../Footer'
import EducationCLRHS8 from '../EducationCLRHS8'

function CLRHS8() {
    window.scrollTo(0,0);
    return (
        <div>
            <EducationCLRHS8/>
            <Footer/>
        </div>
    )
}

export default CLRHS8
